const normalizeBaseUrl = (value) => {
  if (!value) {
    return "";
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return "";
  }

  return trimmed.endsWith("/") ? trimmed : `${trimmed}/`;
};

const getDefaultBase = () => {
  if (typeof window !== "undefined" && window.location) {
    try {
      const { origin, hostname, port, protocol } = window.location;
      const lowerHost = (hostname || "").toLowerCase();

      const isLocalHost = ["localhost", "127.0.0.1", "0.0.0.0"].includes(
        lowerHost
      );
      if (isLocalHost) {
        const fallbackPort = process.env.REACT_APP_BACKEND_PORT || "5000";
        const devFrontendPorts = new Set([
          "3000",
          "5173",
          "4173",
          "8080",
          "4200",
        ]);

        if (!port || devFrontendPorts.has(port)) {
          return `${protocol || "http:"}//${hostname}:${fallbackPort}/`;
        }
        return `${origin.replace(/\/$/, "")}/`;
      }

      return `${origin.replace(/\/$/, "")}/`;
    } catch (error) {
      console.warn(
        "Failed to derive API base from window.location, falling back to localhost:5000",
        error
      );
    }
  }
  return "http://localhost:5000/";
};

export const API_BASE_URL =
  normalizeBaseUrl(process.env.REACT_APP_BASE_URL) || getDefaultBase();

export const getApiUrl = (path = "") => {
  const trimmedPath = String(path || "").replace(/^\/+/, "");
  if (!trimmedPath) {
    return API_BASE_URL.replace(/\/+$/, "/");
  }
  return `${API_BASE_URL}${trimmedPath}`;
};

export default getApiUrl;
